export default __webpack_public_path__ + "fbdb7d50c133b9ce1a5d9e441079d357.svg";